/**
 * Mantém URL do logo da empresa para o sidebar após F5 quando a API de
 * memberships não devolve o campo (login costuma trazer logo no payload).
 *
 * `taskeo.settings.company.cache` deve coincidir com SETTINGS_CACHE_KEY_PREFIX
 * em settings-general-page.
 */
const SIDEBAR_LOGO_PREFIX = 'taskeo.company.sidebarLogo';
const SETTINGS_COMPANY_CACHE_PREFIX = 'taskeo.settings.company.cache';

export function readPersistedCompanyLogoUrl(companyId: string): string | null {
  const id = companyId?.trim();
  if (!id) return null;
  try {
    const sidebar = localStorage.getItem(`${SIDEBAR_LOGO_PREFIX}.${id}`);
    if (sidebar?.trim()) return sidebar.trim();
    const raw = localStorage.getItem(`${SETTINGS_COMPANY_CACHE_PREFIX}.${id}`);
    if (!raw) return null;
    const j = JSON.parse(raw) as { logoUrl?: unknown };
    const lu = j.logoUrl;
    return typeof lu === 'string' && lu.trim() ? lu.trim() : null;
  } catch {
    return null;
  }
}

export function writePersistedCompanyLogoUrl(companyId: string, url: string | null | undefined): void {
  const id = companyId?.trim();
  if (!id) return;
  try {
    const k = `${SIDEBAR_LOGO_PREFIX}.${id}`;
    if (url?.trim()) localStorage.setItem(k, url.trim());
    else localStorage.removeItem(k);
  } catch {
    /* ignore quota / private mode */
  }
}
